import React, { useState, useRef } from "react";
import { Col, Row, Container } from "react-bootstrap";
import { useNavigate, Link } from "react-router-dom";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Calendar } from "primereact/calendar";
import { Dropdown } from "primereact/dropdown";
import { Password } from "primereact/password";
import { Card } from "primereact/card";
import { FileUpload } from "primereact/fileupload";
import config from "../../config";
import CustomToast from "../../components/CustomToast";
import GifLoder from "../../components/GifLoder";
import { Tooltip } from "primereact/tooltip";
import axios from "axios";
import { Image } from "primereact/image";
import { Dialog } from "primereact/dialog";

const MAX_IMAGE_SIZE = 2 * 1024 * 1024;

function New_signup() {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const toastRef = useRef(null);

  const [apiError, setApiError] = useState("");
  const [successDialogVisible, setSuccessDialogVisible] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");

  const showMessage = (severity, detail) => {
    const summary = severity.charAt(0).toUpperCase() + severity.slice(1);

    if (toastRef.current?.show) {
      toastRef.current.show(severity, summary, detail);
    } else {
      console.error("Toast ref unavailable:", detail);
    }
  };

  const [profileImageUrl, setProfileImageUrl] = useState(null);
  const [profileImageFile, setProfileImageFile] = useState(null);

  const [documents, setDocuments] = useState([
    { type: "aadhar", numberField: "aadhar_no", file: null },
    { type: "pan", numberField: "pan_card_no", file: null },
    { type: "passport", numberField: "passport_no", file: null },
  ]);

  const [activeIndex, setActiveIndex] = useState(0);

  const [errors, setErrors] = useState({});

  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    password: "",
    confirmPassword: "",
    officeGmail: "",
    personalEmail: "",
    gender: "",
    date_of_birth: null,

    address: "",
    city: "",
    pincode: "",
    state: "",
    country: "",
    phone: "",
    forte: "",
    other_skills: "",
    nationality: "",
    religion: "",
    marital_status: "",
    employment_of_spouse: "",
    no_of_children: 0,

    bank_name: "",
    bank_account_no: "",
    ifsc_code: "",
    branch_name: "",
    accountHolder_name: "",

    institute: "",
    year_of_passing: "",
    degree_name: "",

    pan_card_no: "",
    passport_no: "",
    aadhar_no: "",

    emergency_name: "",
    emergency_relation: "",
    emergency_phone: "",
  });

  const items = [
    { label: "Basic Info" },
    { label: "Personal Details" },
    { label: "Bank Info" },
    { label: "Education Info" },
    { label: "Documents" },
  ];

  const genderOptions = [
    { label: "Male", value: "male" },
    { label: "Female", value: "female" },
  ];

  const getDocumentFile = (type) => {
    return documents.find((doc) => doc.type === type)?.file || null;
  };

  const isEmpty = (value) => {
    return value === null || value === undefined || value.toString().trim() === "";
  };

  const validateEmail = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((email || "").trim());
  };

  const validatePhone = (phone) => {
    return /^[0-9]{10}$/.test(phone);
  };

  const validatePincode = (pincode) => {
    return /^[0-9]{6}$/.test(pincode);
  };

  const validateYear = (year) => {
    return /^(19|20)\d{2}$/.test(year);
  };

  const validateIFSC = (ifsc) => {
    return /^[A-Z]{4}0[A-Z0-9]{6}$/.test((ifsc || "").toUpperCase());
  };

  const handleInputChange = (e, field) => {
    const value = e.target.value;
    setApiError("");

    if (field === "email") {
      setFormData((prev) => ({
        ...prev,
        email: value,
        officeGmail: value,
      }));

      setErrors((prev) => ({
        ...prev,
        email: "",
        officeGmail: "",
      }));
      return;
    }

    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));

    setErrors((prev) => ({
      ...prev,
      [field]: "",
    }));
  };

  const handleDropdownChange = (field, value) => {
    setApiError("");
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));

    setErrors((prev) => ({
      ...prev,
      [field]: "",
    }));
  };

  const validateImageSize = (file, errorField, imageLabel) => {
    if (file.size <= MAX_IMAGE_SIZE) {
      return true;
    }

    const message = `${imageLabel} must not exceed 2 MB.`;

    setErrors((prev) => ({
      ...prev,
      [errorField]: message,
    }));
    showMessage("error", message);
    return false;
  };

  const handleProfileImageUpload = (e) => {
    const file = e.files[0];
    if (!file) return;

    if (!validateImageSize(file, "profile_image", "Profile image")) {
      e.options.clear();
      return;
    }

    const allowedTypes = ["image/jpeg", "image/jpg", "image/png"];
    if (!allowedTypes.includes(file.type)) {
      showMessage("error", "Profile image must be JPG, JPEG, or PNG.");
      return;
    }

    setProfileImageFile(file);
    setProfileImageUrl(URL.createObjectURL(file));

    setErrors((prev) => ({
      ...prev,
      profile_image: "",
    }));
  };

  const onDocumentSelect = (e, type) => {
    const file = e.files[0];
    if (!file) return;

    const documentLabel = type === "aadhar" ? "Aadhaar" : type.toUpperCase();

    if (!validateImageSize(file, `${type}_file`, `${documentLabel} image`)) {
      e.options.clear();
      return;
    }

    const allowedTypes = ["image/jpeg", "image/jpg", "image/png"];

    if (!allowedTypes.includes(file.type)) {
      showMessage("error", `${type.toUpperCase()} image must be JPG, JPEG, or PNG.`);
      return;
    }

    setDocuments((prev) =>
      prev.map((doc) => (doc.type === type ? { ...doc, file } : doc))
    );

    setErrors((prev) => ({
      ...prev,
      [`${type}_file`]: "",
    }));

    showMessage("success", `${type.toUpperCase()} image selected successfully.`);
    e.options.clear();
  };

  const onDocumentRemove = (type) => {
    setDocuments((prev) =>
      prev.map((doc) => (doc.type === type ? { ...doc, file: null } : doc))
    );
  };

  const validateStep = (stepIndex) => {
    const newErrors = {};

    if (stepIndex === 0) {
      if (!profileImageFile) {
        newErrors.profile_image = "Profile image is required.";
      }

      if (isEmpty(formData.first_name)) {
        newErrors.first_name = "Please enter first name.";
      }

      if (isEmpty(formData.last_name)) {
        newErrors.last_name = "Please enter last name.";
      }

      if (isEmpty(formData.email)) {
        newErrors.email = "Please enter Graphe email.";
      } else if (!validateEmail(formData.email)) {
        newErrors.email = "Please enter a valid Graphe email address.";
      }

      if (isEmpty(formData.officeGmail)) {
        newErrors.officeGmail = "Official mail is required.";
      } else if (!validateEmail(formData.officeGmail)) {
        newErrors.officeGmail = "Please enter a valid official mail address.";
      }

      if (isEmpty(formData.personalEmail)) {
        newErrors.personalEmail = "Please enter personal mail.";
      } else if (!validateEmail(formData.personalEmail)) {
        newErrors.personalEmail = "Please enter a valid personal mail address.";
      }

      if (
        !isEmpty(formData.personalEmail) &&
        !isEmpty(formData.email) &&
        formData.personalEmail.trim().toLowerCase() === formData.email.trim().toLowerCase()
      ) {
        newErrors.personalEmail = "Personal mail must be different from Graphe mail.";
      }

      if (
        !isEmpty(formData.personalEmail) &&
        !isEmpty(formData.officeGmail) &&
        formData.personalEmail.trim().toLowerCase() === formData.officeGmail.trim().toLowerCase()
      ) {
        newErrors.personalEmail = "Personal mail must be different from official mail.";
      }

      if (isEmpty(formData.password)) {
        newErrors.password = "Please enter password.";
      } else if (formData.password.length < 6) {
        newErrors.password = "Password must be at least 6 characters long.";
      } else if (
        !/(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])/.test(formData.password)
      ) {
        newErrors.password =
          "Password must include uppercase, lowercase, number, and special character.";
      }

      // ✅ Only check confirm password IF password itself is valid
      if (!newErrors.password) {
        if (isEmpty(formData.confirmPassword)) {
          newErrors.confirmPassword = "Please confirm your password.";
        } else if (formData.password !== formData.confirmPassword) {
          newErrors.confirmPassword = "Passwords do not match.";
        }
      }

      if (isEmpty(formData.confirmPassword)) {
        newErrors.confirmPassword = "Please confirm your password.";
      } else if (formData.password !== formData.confirmPassword) {
        newErrors.confirmPassword = "Passwords do not match.";
      }

      if (isEmpty(formData.phone)) {
        newErrors.phone = "Please enter phone number.";
      } else if (!validatePhone(formData.phone)) {
        newErrors.phone = "Phone number must be exactly 10 digits.";
      }

      if (isEmpty(formData.gender)) {
        newErrors.gender = "Please select gender.";
      }

      if (!formData.date_of_birth) {
        newErrors.date_of_birth = "Please select date of birth.";
      }
    }

    if (stepIndex === 1) {
      if (isEmpty(formData.forte)) {
        newErrors.forte = "Please enter forte.";
      }
      if (isEmpty(formData.other_skills)) {
        newErrors.other_skills = "Please enter other skills.";
      }
      if (isEmpty(formData.nationality)) {
        newErrors.nationality = "Please enter nationality.";
      }
      if (isEmpty(formData.religion)) {
        newErrors.religion = "Please enter religion.";
      }
      if (isEmpty(formData.marital_status)) {
        newErrors.marital_status = "Please enter marital status.";
      }

      if (isEmpty(formData.address)) {
        newErrors.address = "Please enter address.";
      }

      if (isEmpty(formData.city)) {
        newErrors.city = "Please enter city.";
      }

      if (isEmpty(formData.pincode)) {
        newErrors.pincode = "Please enter pincode.";
      } else if (!validatePincode(formData.pincode)) {
        newErrors.pincode = "Pincode must be exactly 6 digits.";
      }

      if (isEmpty(formData.state)) {
        newErrors.state = "Please enter state.";
      }

      if (isEmpty(formData.country)) {
        newErrors.country = "Please enter country.";
      }
    }

    if (stepIndex === 2) {
      if (isEmpty(formData.bank_name)) {
        newErrors.bank_name = "Please enter bank name.";
      }

      if (isEmpty(formData.bank_account_no)) {
        newErrors.bank_account_no = "Please enter bank account number.";
      }

      if (isEmpty(formData.ifsc_code)) {
        newErrors.ifsc_code = "Please enter IFSC code.";
      } else if (!validateIFSC(formData.ifsc_code)) {
        newErrors.ifsc_code =
          "Please enter a valid 11-character IFSC code. Example format: CNRB0XXXXXX";
      }

      if (isEmpty(formData.branch_name)) {
        newErrors.branch_name = "Please enter branch name.";
      }

      if (isEmpty(formData.accountHolder_name)) {
        newErrors.accountHolder_name = "Please enter account holder name.";
      }
    }

    if (stepIndex === 3) {
      if (isEmpty(formData.institute)) {
        newErrors.institute = "Please enter institute name.";
      }

      if (isEmpty(formData.year_of_passing)) {
        newErrors.year_of_passing = "Please enter year of passing.";
      } else if (!validateYear(formData.year_of_passing)) {
        newErrors.year_of_passing = "Please enter a valid 4-digit passing year.";
      }

      if (isEmpty(formData.degree_name)) {
        newErrors.degree_name = "Please enter degree name.";
      }
    }

    if (stepIndex === 4) {
      const aadharFile = getDocumentFile("aadhar");
      const panFile = getDocumentFile("pan");
      const passportFile = getDocumentFile("passport");

      if (isEmpty(formData.aadhar_no)) {
        newErrors.aadhar_no = "Aadhaar number is mandatory.";
      }
      if (!aadharFile) {
        newErrors.aadhar_file = "Aadhaar image is mandatory.";
      }

      if (isEmpty(formData.pan_card_no)) {
        newErrors.pan_card_no = "PAN number is mandatory.";
      }
      if (!panFile) {
        newErrors.pan_file = "PAN image is mandatory.";
      }

      if (!isEmpty(formData.passport_no) && !passportFile) {
        newErrors.passport_file = "Passport number is entered, so passport image is required.";
      }

      if (passportFile && isEmpty(formData.passport_no)) {
        newErrors.passport_no =
          "Please enter passport number for the uploaded passport image.";
      }

      if (aadharFile && isEmpty(formData.aadhar_no)) {
        newErrors.aadhar_no =
          "Please enter Aadhaar number for the uploaded Aadhaar image.";
      }

      if (panFile && isEmpty(formData.pan_card_no)) {
        newErrors.pan_card_no = "Please enter PAN number for the uploaded PAN image.";
      }
    }

    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) {
      const firstError = Object.values(newErrors)[0];
      showMessage("error", firstError);
      return false;
    }

    return true;
  };

  const validateForm = () => {
    for (let step = 0; step < items.length; step++) {
      const isValid = validateStep(step);
      if (!isValid) {
        setActiveIndex(step);
        return false;
      }
    }
    return true;
  };

  const handleNext = () => {
    const isValid = validateStep(activeIndex);
    if (!isValid) return;
    setActiveIndex((prev) => prev + 1);
  };

  const handleSubmit = async () => {
    setApiError("");

    if (!validateForm()) {
      return;
    }

    setLoading(true);

    try {
      const formDataToSend = new FormData();

      Object.keys(formData).forEach((key) => {
        if (
          formData[key] !== null &&
          formData[key] !== undefined
        ) {
          let value = formData[key];

          if (key === "date_of_birth" && value) {
            const localDate = new Date(value);

            const year = localDate.getFullYear();
            const month = String(
              localDate.getMonth() + 1
            ).padStart(2, "0");

            const day = String(
              localDate.getDate()
            ).padStart(2, "0");

            value = `${year}-${month}-${day}`;
          }

          formDataToSend.append(key, value);
        }
      });

      if (profileImageFile) {
        formDataToSend.append(
          "profile_image",
          profileImageFile
        );
      }

      documents.forEach((doc) => {
        if (doc.file) {
          formDataToSend.append(
            "documents",
            doc.file
          );
        }
      });

      // IMPORTANT:
      // Do not manually set Content-Type
      const res = await axios.post(
        `${config.apiBASEURL}/authentication/register`,
        formDataToSend
      );

      // Axios resolves this block only for a successful 2xx response. Do not require
      // one exact status code, and do not navigate immediately: doing so unmounted the
      // toast before it could render and made a saved registration look unsuccessful.
      setSuccessMessage(
        res.data?.message || "Your registration was completed successfully."
      );
      setSuccessDialogVisible(true);
    } catch (error) {
      console.error(
        "Registration full error:",
        error
      );

      const errorMessage =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        error?.message ||
        "Something went wrong";

      setApiError(errorMessage);
      showMessage("error", errorMessage);
    } finally {
      setLoading(false);
    }
  };

  const renderError = (field) => (
    <div style={{ minHeight: "20px" }}>
      {errors[field] ? (
        <small className="text-danger d-block mt-1" style={{ fontSize: "12px" }}>
          {errors[field]}
        </small>
      ) : null}
    </div>
  );

  const renderPersonalStep = () => (
    <Row className="p-fluid grid">
      <Col lg={12} md={12} className="mb-4">
        <label>
          Basic Details <span>*</span>
        </label>
      </Col>

      <Col lg={3} md={6} className="mb-4 position-relative">
        <Tooltip target=".custom-target-icon" />
        <div
          className="position-relative"
          style={{ width: "120px", height: "120px" }}
        >
          <img
            src={
              profileImageUrl
                ? profileImageUrl
                : require("../../assets/images/no_user.png")
            }
            alt=""
            style={{ width: "120px", height: "120px", objectFit: "cover" }}
            className="rounded-circle"
          />
          <FileUpload
            mode="basic"
            name="profile_image"
            accept="image/*"
            maxFileSize={MAX_IMAGE_SIZE}
            onValidationFail={(file) =>
              validateImageSize(file, "profile_image", "Profile image")
            }
            customUpload
            uploadHandler={handleProfileImageUpload}
            auto
            className="FlUpload"
            title="Allowed file types JPG, PNG. Maximum size 2 MB"
          />
        </div>
        <i
          className="custom-target-icon pi pi-info-circle text-danger"
          data-pr-tooltip="Allowed file types JPG, PNG. Maximum size 2 MB"
          data-pr-position="right"
          data-pr-at="right+5 top"
          data-pr-my="left center-2"
          style={{
            fontSize: "16px",
            cursor: "pointer",
            position: "absolute",
            top: "5px",
            left: "5px",
          }}
        ></i>
        {renderError("profile_image")}
      </Col>

      <Col lg={9} md={6}>
        <InputText
          placeholder="First Name"
          value={formData.first_name}
          onChange={(e) => handleInputChange(e, "first_name")}
        />
        {renderError("first_name")}

        <div className="mt-2">
          <InputText
            placeholder="Last Name"
            value={formData.last_name}
            onChange={(e) => handleInputChange(e, "last_name")}
          />
          {renderError("last_name")}
        </div>
      </Col>

      <Col lg={6} md={6}>
        <InputText
          placeholder="Graphe Email"
          value={formData.email}
          onChange={(e) => handleInputChange(e, "email")}
        />
        {renderError("email")}
      </Col>

      <Col lg={6} md={6}>
        <InputText
          placeholder="Official Mail"
          value={formData.officeGmail}
          onChange={(e) => handleInputChange(e, "officeGmail")}
          readOnly
        />
        {renderError("officeGmail")}
      </Col>

      <Col lg={6} md={6}>
        <InputText
          placeholder="Personal Mail"
          value={formData.personalEmail}
          onChange={(e) => handleInputChange(e, "personalEmail")}
        />
        {renderError("personalEmail")}
      </Col>

      <Col lg={6} md={6}>
        <InputText
          placeholder="Phone"
          value={formData.phone}
          onChange={(e) => handleInputChange(e, "phone")}
        />
        {renderError("phone")}
      </Col>

      <Col lg={6} md={6}>
        <Password
          placeholder="Password"
          value={formData.password}
          onChange={(e) => handleInputChange(e, "password")}
          toggleMask
          feedback={false}
        />
        {renderError("password")}
      </Col>

      <Col lg={6} md={6}>
        <Password
          placeholder="Confirm Password"
          value={formData.confirmPassword}
          onChange={(e) => handleInputChange(e, "confirmPassword")}
          toggleMask
          feedback={false}
        />
        {renderError("confirmPassword")}
      </Col>

      <Col lg={6} md={6} className="pe-0">
        <Dropdown
          placeholder="Gender"
          className="mt-0"
          options={genderOptions}
          value={formData.gender}
          onChange={(e) => handleDropdownChange("gender", e.value)}
        />
        {renderError("gender")}
      </Col>

      <Col lg={6} md={6} className="mb-3 mt-0">
        <Calendar
          placeholder="Date of Birth"
          value={formData.date_of_birth}
          onChange={(e) => handleDropdownChange("date_of_birth", e.value)}
          dateFormat="dd/mm/yy"
          className="w-100 h-auto"
        />
        {renderError("date_of_birth")}
      </Col>
    </Row>
  );

  const renderPersonalInfoStep = () => (
    <Row className="p-fluid grid">
      <Col lg={6} md={6}>
        <label>
          Personal Identification <span>*</span>
        </label>
      </Col>

      <Col lg={12} md={12}>
        <InputText
          placeholder="Forte"
          value={formData.forte}
          onChange={(e) => handleInputChange(e, "forte")}
        />
        {renderError("forte")}
      </Col>

      <Col lg={6} md={6}>
        <InputText
          placeholder="Specialization"
          value={formData.other_skills}
          onChange={(e) => handleInputChange(e, "other_skills")}
        />
        {renderError("other_skills")}
      </Col>

      <Col lg={6} md={6}>
        <InputText
          placeholder="Nationality"
          value={formData.nationality}
          onChange={(e) => handleInputChange(e, "nationality")}
        />
        {renderError("nationality")}
      </Col>

      <Col lg={6} md={6}>
        <InputText
          placeholder="Religion"
          value={formData.religion}
          onChange={(e) => handleInputChange(e, "religion")}
        />
        {renderError("religion")}
      </Col>

      <Col lg={6} md={6}>
        <InputText
          placeholder="Marital Status"
          value={formData.marital_status}
          onChange={(e) => handleInputChange(e, "marital_status")}
        />
        {renderError("marital_status")}
      </Col>

      <Col lg={6} md={6}>
        <InputText
          placeholder="Employment of Spouse"
          value={formData.employment_of_spouse}
          onChange={(e) => handleInputChange(e, "employment_of_spouse")}
        />
      </Col>

      <Col lg={6} md={6}>
        <InputText
          type="number"
          placeholder="No of Children"
          value={formData.no_of_children}
          onChange={(e) =>
            handleInputChange(
              {
                target: {
                  value: e.target.value === "" ? 0 : parseInt(e.target.value, 10),
                },
              },
              "no_of_children"
            )
          }
        />
      </Col>

      <Col lg={6} md={6} className="mt-2">
        <label>
          Address Details <span>*</span>
        </label>
      </Col>

      <Col lg={12} md={12}>
        <InputText
          placeholder="Address"
          value={formData.address}
          onChange={(e) => handleInputChange(e, "address")}
        />
        {renderError("address")}
      </Col>

      <Col lg={6} md={6}>
        <InputText
          placeholder="City"
          value={formData.city}
          onChange={(e) => handleInputChange(e, "city")}
        />
        {renderError("city")}
      </Col>

      <Col lg={6} md={6}>
        <InputText
          placeholder="Pincode"
          value={formData.pincode}
          onChange={(e) => handleInputChange(e, "pincode")}
        />
        {renderError("pincode")}
      </Col>

      <Col lg={6} md={6}>
        <InputText
          placeholder="State"
          value={formData.state}
          onChange={(e) => handleInputChange(e, "state")}
        />
        {renderError("state")}
      </Col>

      <Col lg={6} md={6}>
        <InputText
          placeholder="Country"
          value={formData.country}
          onChange={(e) => handleInputChange(e, "country")}
        />
        {renderError("country")}
      </Col>
    </Row>
  );

  const renderBankStep = () => (
    <Row className="p-fluid grid">
      <Col lg={12} md={12}>
        <label>
          Bank Details <span>*</span>
        </label>
      </Col>

      <Col lg={6} md={6}>
        <InputText
          placeholder="Bank Name"
          value={formData.bank_name}
          onChange={(e) => handleInputChange(e, "bank_name")}
        />
        {renderError("bank_name")}
      </Col>

      <Col lg={6} md={6}>
        <InputText
          placeholder="Account No"
          value={formData.bank_account_no}
          onChange={(e) => handleInputChange(e, "bank_account_no")}
        />
        {renderError("bank_account_no")}
      </Col>

      <Col lg={6} md={6}>
        <InputText
          placeholder="IFSC Code"
          value={formData.ifsc_code}
          onChange={(e) => handleInputChange(e, "ifsc_code")}
          style={{ textTransform: "uppercase" }}
        />
        {renderError("ifsc_code")}
      </Col>

      <Col lg={6} md={6}>
        <InputText
          placeholder="Branch Name"
          value={formData.branch_name}
          onChange={(e) => handleInputChange(e, "branch_name")}
        />
        {renderError("branch_name")}
      </Col>

      <Col lg={6} md={6}>
        <InputText
          placeholder="Account Holder Name"
          value={formData.accountHolder_name}
          onChange={(e) => handleInputChange(e, "accountHolder_name")}
        />
        {renderError("accountHolder_name")}
      </Col>
    </Row>
  );

  const renderEducationStep = () => (
    <Row className="p-fluid grid">
      <Col lg={12} md={12}>
        <label>
          Educational Details <span>*</span>
        </label>
      </Col>

      <Col lg={6} md={6}>
        <InputText
          placeholder="Institute"
          value={formData.institute}
          onChange={(e) => handleInputChange(e, "institute")}
        />
        {renderError("institute")}
      </Col>

      <Col lg={6} md={6}>
        <InputText
          placeholder="Year of Passing"
          value={formData.year_of_passing}
          onChange={(e) => handleInputChange(e, "year_of_passing")}
        />
        {renderError("year_of_passing")}
      </Col>

      <Col lg={6} md={6}>
        <InputText
          placeholder="Degree Name"
          value={formData.degree_name}
          onChange={(e) => handleInputChange(e, "degree_name")}
        />
        {renderError("degree_name")}
      </Col>
    </Row>
  );

  const renderDocumentStep = () => (
    <Row className="p-fluid grid">
      <Col lg={12}>
        <label>
          Document Details <span>*</span>
          <small
            className="ms-2"
            style={{ fontSize: "12px", fontWeight: "400", color: "#939393" }}
          >
            (JPG, JPEG, PNG file only)
          </small>
        </label>
        <small className="d-block mt-1 text-muted">
          Aadhaar and PAN are mandatory. Passport is optional.
        </small>
      </Col>

      {documents.map((doc) => (
        <Col
          lg={12}
          md={12}
          key={doc.type}
          className="d-flex align-items-start gap-2 mb-3"
        >
          <div className="d-flex flex-column w-100">
            <div className="d-flex w-100 align-items-center gap-2">
              <InputText
                placeholder={`${doc.type.toUpperCase()} Number`}
                value={formData[doc.numberField]}
                onChange={(e) => handleInputChange(e, doc.numberField)}
              />

              <FileUpload
                mode="basic"
                accept=".jpg,.jpeg,.png"
                maxFileSize={MAX_IMAGE_SIZE}
                onValidationFail={(file) => {
                  const documentLabel =
                    doc.type === "aadhar" ? "Aadhaar" : doc.type.toUpperCase();
                  validateImageSize(
                    file,
                    `${doc.type}_file`,
                    `${documentLabel} image`
                  );
                }}
                auto
                customUpload
                uploadHandler={(e) => onDocumentSelect(e, doc.type)}
                disabled={!formData[doc.numberField]}
              />
            </div>

            {doc.type === "aadhar" && renderError("aadhar_no")}
            {doc.type === "aadhar" && renderError("aadhar_file")}

            {doc.type === "pan" && renderError("pan_card_no")}
            {doc.type === "pan" && renderError("pan_file")}

            {doc.type === "passport" && renderError("passport_no")}
            {doc.type === "passport" && renderError("passport_file")}
          </div>

          <div>
            {doc.file && (
              <div
                className="position-relative border upimgdoc"
                style={{ width: "100px", height: "100px" }}
              >
                <Image
                  src={URL.createObjectURL(doc.file)}
                  alt={doc.type}
                  preview
                  className="w-100 h-100"
                />
                <Button
                  type="button"
                  icon="pi pi-times"
                  severity="danger"
                  className="position-absolute p-1 text-light shadow"
                  style={{ top: 0, right: 0, width: "23px", height: "23px" }}
                  onClick={() => onDocumentRemove(doc.type)}
                />
              </div>
            )}
          </div>
        </Col>
      ))}
    </Row>
  );

  const renderContent = () => {
    switch (activeIndex) {
      case 0:
        return renderPersonalStep();
      case 1:
        return renderPersonalInfoStep();
      case 2:
        return renderBankStep();
      case 3:
        return renderEducationStep();
      case 4:
        return renderDocumentStep();
      default:
        return null;
    }
  };

  return (
    <>
      {loading && (
        <div className="loderDiv">
          <GifLoder />
        </div>
      )}

      <Container className="login-card signupCard">
        <Row className="mx-0 p-0 align-items-center maxHig">
          <Col lg={6} md={12}>
            <Card className="mt-3 p-0">
              {apiError && (
                <div
                  className="mb-3 px-3 py-2"
                  style={{
                    background: "#fff1f0",
                    border: "1px solid #ffccc7",
                    color: "#cf1322",
                    borderRadius: "8px",
                    fontSize: "13px",
                  }}
                >
                  {apiError}
                </div>
              )}

              {renderContent()}

              <div className="d-flex justify-content-between mt-4 gap-4">
                {activeIndex > 0 && (
                  <Button
                    label="Back"
                    icon="pi pi-arrow-left"
                    onClick={() => setActiveIndex(activeIndex - 1)}
                    className="p-button-secondary"
                    disabled={loading}
                  />
                )}

                {activeIndex < items.length - 1 ? (
                  <Button
                    label="Next"
                    iconPos="right"
                    className="loginbtn"
                    onClick={handleNext}
                    disabled={loading}
                  />
                ) : (
                  <Button
                    label="Submit"
                    icon="pi pi-check"
                    onClick={handleSubmit}
                    severity="success"
                    className="loginbtn"
                    disabled={loading}
                  />
                )}
              </div>
            </Card>

            <p className="mt-4 text-center">
              Already have an account? <Link to="/Graphe/">Login</Link>
            </p>
          </Col>

          <Col lg={4} md={4}></Col>
        </Row>
      </Container>

      <CustomToast ref={toastRef} />
      <Dialog
        visible={successDialogVisible}
        closable={false}
        modal
        header="Registration successful"
        style={{ width: "min(430px, 92vw)" }}
        footer={
          <div className="d-flex justify-content-end">
            <Button
              label="Continue to login"
              icon="pi pi-sign-in"
              onClick={() => navigate("/Graphe/login", { replace: true })}
              autoFocus
            />
          </div>
        }
      >
        <div className="d-flex align-items-start gap-3">
          <i
            className="pi pi-check-circle text-success"
            aria-hidden="true"
            style={{ fontSize: "2rem" }}
          />
          <div>
            <p className="mb-1 fw-semibold">Your form has been submitted.</p>
            <p className="mb-0 text-muted">{successMessage}</p>
          </div>
        </div>
      </Dialog>
    </>
  );
}

export default New_signup;
